import u from "./ghl-ui.es1543.js";
import f from "./ghl-ui.es1544.js";
import m from "./ghl-ui.es1540.js";
import l from "./ghl-ui.es1541.js";
import X from "./ghl-ui.es1542.js";
import p from "./ghl-ui.es1545.js";
import { Parser as h } from "./ghl-ui.es1613.js";
import { timezonePatterns as n } from "./ghl-ui.es1615.js";
import { parseTimezonePattern as s } from "./ghl-ui.es1614.js";
var _ = /* @__PURE__ */ function(c) {
  l(o, c);
  var a = X(o);
  function o() {
    var r;
    u(this, o);
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return r = a.call.apply(a, [this].concat(t)), p(m(r), "priority", 10), p(m(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return f(o, [{
    key: "parse",
    value: function(e, t) {
      switch (t) {
        case "X":
          return s(n.basicOptionalMinutes, e);
        case "XX":
          return s(n.basic, e);
        case "XXXX":
          return s(n.basicOptionalSeconds, e);
        case "XXXXX":
          return s(n.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return s(n.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, t, i) {
      return t.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), o;
}(h);
export {
  _ as ISOTimezoneWithZParser
};
